<template>
  <div id="environment">
    <el-container>
      <el-main style="border:1px solid black;height:1000px">
        <el-row>
          <el-select v-model="selectA" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="getA">发送请求a</el-button>
        </el-row>
        <el-row style="margin-top:20px">
          <el-input
            type="textarea"
            :autosize="{ minRows: 30, maxRows: 100}"
            placeholder="请输入内容"
            v-model="textareaA"
          ></el-input>
        </el-row>
      </el-main>
      <el-main style="margin-left:5px;border:1px solid black;height:1000px">
        <el-row>
          <el-select v-model="selectB" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="getB">发送请求b</el-button>
        </el-row>
        <el-row style="margin-top:20px">
          <el-input
            type="textarea"
            :autosize="{ minRows: 30, maxRows: 100}"
            placeholder="请输入内容"
            v-model="textareaB"
          ></el-input>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [
        {
          value: 'http://site.zs.yunrui.net/api/',
          label: 'site-不带证书'
        },
        {
          value: 'https://site.zs.yunrui.net/api/',
          label: 'site-带证书'
        },
        {
          value: 'http://api.saas.yunrui.net/api/',
          label: 'api-不带证书'
        },
        {
          value: 'https://api.saas.yunrui.net/api/',
          label: 'api-带证书'
        }
      ],
      textareaA: '',
      selectA: 'http://site.zs.yunrui.net/api/',
      textareaB: '',
      selectB: 'http://site.zs.yunrui.net/api/'
    }
  },
  methods: {
    getA: function() {
      this.$api.login
        .a(this.selectA)
        .then(res => {
          this.textareaA = res.replace(/\\/g, '')
        })
        .catch()
    },
    getB: function() {
      this.$api.login
        .b(this.selectB)
        .then(res => {
          this.textareaB = res.replace(/\\/g, '')
        })
        .catch()
    }
  }
}
</script>
<style scoped>
</style>